import RefreshIcon from "@mui/icons-material/Refresh";
import { Avatar, Box, Grid, Link, Tooltip, Typography } from "@mui/material";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import { getAllDeliveryReports } from "../../slices/Reports/DeliveryReportSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import DeliveryReportView from "./DeliveryReportView";
import FilterDeliveryReport from "./FilterDeliveryReport";

export default function DeliveryReport() {
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const [clear, setClear] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const { darkMode } = useContext(ThemeContext);
  const [date, setDate] = useState();

  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };

  var today = new Date();
  var endDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T23:59:59";
  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T00:00";

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const [filter, setFilter] = React.useState({
    deliveresStartDate: "",
    deliveresEndDate: "",
    deliveryCompanyName: "",
  });

  const defaultPaging = {
    page: 1,
    rowsPerPage: 10,
  };

  const defaultFilter = {
    deliveresStartDate: "",
    deliveresEndDate: "",
    deliveryCompanyName: "",
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setRowsPerPage(size);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  const handleOpen = () => {
    setOpen(true);
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const loadData = (filter, paging) => {
    dispatch(getAllDeliveryReports(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          setTotalRecords(data.data.totalCount);
          setPage(data.data.curPage);
          setTotalPages(data.data.totalPages);
          setRows(data.data.deliveryReports);
        } else {
          setRows([]);
        }
      })
      .catch((er) => { });
  };

  const handleFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      deliveresStartDate: CommonUtil.formatToUtc(data.deliveresStartDate),
      deliveresEndDate: CommonUtil.formatToUtc(data.deliveresEndDate),
      deliveryCompanyName: data.deliveryCompanyName,
    });
  };

  const getStatusStyles = (status) => {
    switch (status) {
      case "open":
        return { color: "#0073e6", backgroundColor: "#e6f4ff" };
      case "closed":
        return { color: "#b30000", backgroundColor: "#ffe6e6" };
      case "collected":
        return { color: "#b30000", backgroundColor: "#ffe6e6" };
      default:
        return null;
    }
  };

  const StatusTab = ({ status }) => {
    const styles = getStatusStyles(status);
    if (!styles) {
      return null;
    }
    return (
      <Box
        style={{
          width: "100px",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <Grid style={{ flex: "0 0 150px" }}>
          <Typography style={{ ...styles, padding: "4px" }}>
            {status === "open"
              ? "Open"
              : status === "closed"
                ? "Closed"
                : status === "collected"
                  ? "Collected"
                  : ""}
          </Typography>
        </Grid>
      </Box>
    );
  };

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "dd-MM-yyyy":
        return "dd-MM-yyyy HH:mm";
      case "MM-dd-yyyy":
        return "MM-dd-yyyy HH:mm";
      case "yyyy-MM-dd":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };

  const renderCell = (date) => (params) => {
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(params.row.createdAt)
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
          ? "MM-DD-YYYY HH:mm"
          : date === "yyyy-MM-dd HH:mm"
            ? "YYYY-MM-DD HH:mm"
            : ""
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 25) {
      return text.substring(0, 25) + "...";
    } else {
      return text;
    }
  };

  const ZoomHandaler = (params) => (
    <SimpleDialogDemo
      button={
        <Avatar
          alt={params.row.personImageObjectKey}
          src={
            params.row.personImageObjectKey !== undefined
              ? params.row.personImageObjectKey
              : null
          }
        ></Avatar>
      }
      child={
        <Avatar
          style={{
            width: "300px",
            height: "300px",
            border: "1px solid #FFFF",
            fontSize: "100px",
            borderRadius: "50%",
          }}
          alt={params.row.personImageObjectKey}
          src={
            params.row.personImageObjectKey !== undefined
              ? params.row.personImageObjectKey
              : null
          }
        ></Avatar>
      }
    />
  );

  const columns = React.useMemo(
    () => [
      {
        field: "Person Image",
        headerName: "",
        sortable: false,
        width: 10,
        renderCell: (params) => {
          // return ZoomHandaler(params);
        },
      },
      {
        field: "UserName",
        headerName: t("Recipient"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) => params.row.recipientName,
        renderCell: (params) => (
          <Tooltip
            title={` ${params.row.recipientName}`}
            placement="bottom-start"
          >
            <span>{handleTextOverflow(params.row?.recipientName)}</span>
          </Tooltip>
        ),
      },
      {
        field: "TenantName",
        headerName: t("Tenant"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) => params.row.tenantCompanyName,
        renderCell: (params) => (
          <Tooltip
            title={` ${params.row.tenantCompanyName}`}
            placement="bottom-start"
          >
            <span>{handleTextOverflow(params.row?.tenantCompanyName)}</span>
          </Tooltip>
        ),
      },
      {
        field: "deliveryCompanyName",
        headerName: t("DELIVERY_COMPANY"),
        flex: 1,
        minWidth: 190,
        valueGetter: (params) => params.row.deliveryCompanyName,
      },
      {
        field: "createdAt",
        headerName: t("DELIVERY_TIME"),
        flex: 1,
        minWidth: 160,
        renderCell: renderCell(formatDate(companySettings.dateFormat)),
      },

      {
        field: "status",
        headerName: "Status",
        flex: 1,
        minWidth: 190,
        renderCell: (params) => <StatusTab status={params.row.status} />,
      },

      {
        field: "remarks",
        headerName: t("COMMON016"),
        flex: 1,
        minWidth: 160,
        valueGetter: (params) => params.row.remarks,
        renderCell: (params) => (
          <Tooltip title={` ${params.row.remarks}`} placement="bottom-start">
            <span>{handleTextOverflow(params.row.remarks)}</span>
          </Tooltip>
        ),
      },

      {
        field: "Actions",
        headerName: t("CUSTDATABLE16"),
        type: "actions",
        flex: 1,
        minWidth: 190,
        headerAlign: "center",
        getActions: (params) => [
          <DeliveryReportView
            title="Delivery Report Details"
            rowData={params.row}
          />,
        ],
      },
    ],
    []
  );

  return (
    <>
      <HeaderToolbar title={t("SUBSCRIPTIONDELIVERREPORT")} />
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        style={{ gap: "6px", padding: "10px 0px 10px 10px" }}
      >
        {clear && (
          <Box item>
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          </Box>
        )}

        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadData(filter, paging)} />
          </Box>
        </Tooltip>

        <Box item>
          <FilterDeliveryReport
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleFilter(data)}
            date={formatDate(companySettings.dateFormat)}
          />
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
    </>
  );
}
